<template>
  <div class="SetRemarkName">
    <van-nav-bar
      title="设置备注"
      fixed
      right-text="修改"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-field v-model="remarkName" border clearable />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "SetRemarkName",
  data() {
    return {
      friend_id: "",
      remarkName: "",
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token")
    };
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "UserInfoSet",
        query: {
          friend_id: this.friend_id
        }
      });
    },
    // 修改
    onClickRight() {
      var params = {
        friend_id: this.friend_id,
        remarkName: this.remarkName,
        token: this.token,
        u_id: this.u_id
      };
      var url =
        this.Conf.serverUrl + "User/updateRemarkName" + "?num=" + Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              this.$toast.success(response.data.msg);
              // this.$router.rush(-1);
              this.onClickLeft();
              break;
            case 40001:
              this.$toast.fail(response.data.msg);
              break;
          }
        })
        .catch(error => {});
    }
  },
  created() {
    var params = this.$route.query;
    this.friend_id = params.friend_id;
    this.remarkName = params.friend_name;
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/SetRemarkName.vue